import request from '@/axios';

/** 封禁用户设备分页搜索 */
export const getList = (params) => {
  return request({
    url: '/lebo-security/web/blockedUserDevice/page',
    method: 'get',
    params
  })
}

/** 新增封禁用户设备 */
export const addDevice = (data) => {
  return request({
    url: '/lebo-security/web/blockedUserDevice/saveOrUpdate',
    method: 'post',
    data
  })
}

/** 编辑封禁用户设备 */
export const editDevice = (data) => {
  return request({
    url: '/lebo-security/web/blockedUserDevice/saveOrUpdate',
    method: 'post',
    data
  })
}

/** 删除封禁用户设备 */
export const deleteDevice = (data) => {
  return request({
    url: `/lebo-security/web/blockedUserDevice/remove?id=${data}`,
    method: 'post',
  })
}